/**
 * This utility function encodes the form data into raw data.
 * @param {Object} data object that needs encoding
 */
export default function encode(data) {
	return Object.keys(data)
		.map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
		.join('&');
}
